module.exports = __webpack_public_path__ + "4d26e151b2.jpg";